import { Link } from 'react-router-dom'
import { EmptyState } from '../components/States'

/** Where RequireAuth sends a signed-in user whose role lacks the capability. */
export function ForbiddenPage() {
  return (
    <div className="wrap" style={{ maxWidth: 700 }}>
      <div className="card card-p" style={{ padding: '48px 40px' }}>
        <EmptyState
          icon="⛔"
          title="Your role does not include this screen"
          body="Ask an Admin in your workspace to change your role, or switch to a task your role covers."
          action={
            <div className="row" style={{ justifyContent: 'center' }}>
              <Link className="btn btn-p" to="/app">
                ← Back to home
              </Link>
            </div>
          }
        />
      </div>
    </div>
  )
}

export function NotFoundPage() {
  return (
    <div className="wrap" style={{ maxWidth: 700 }}>
      <div className="card card-p" style={{ padding: '48px 40px' }}>
        <EmptyState
          icon="?"
          title="That page does not exist"
          body="The link may be out of date, or the screen may have moved."
          action={
            <div className="row" style={{ justifyContent: 'center' }}>
              <Link className="btn btn-p" to="/app">
                ← Back to home
              </Link>
            </div>
          }
        />
      </div>
    </div>
  )
}
